// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .api-docs-viewer {
    min-height: 100vh;
  } */

.endpoint-path {
  font-weight: 600;
}

.sidebar {
  background-color: var(--sidemenu-background-color) !important;
  border-right: 1px solid var(--border-color);
}

.sidebar-header {
  border-bottom: 1px solid var(--border-color);
}

.menu {
  background-color: var(--sidemenu-background-color) !important;
  border: none;
}

.endpoint-content {
  padding: 24px;
  /* max-width: 900px; */
  margin: 0 auto;
}

/* API Test Modal Styling */
.api-test-modal .ant-modal-content {
  padding: 0;
  border-radius: 8px;
  box-shadow:
    0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 3px 6px -4px rgba(0, 0, 0, 0.12),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08);
}

.api-test-modal .ant-modal-body {
  padding: 0;
  max-height: calc(100vh - 120px);
  overflow-y: auto;
  overflow-x: hidden;
}

.api-test-modal .ant-modal-body::-webkit-scrollbar {
  width: 6px;
}

.api-test-modal .ant-modal-body::-webkit-scrollbar-track {
  background: #f5f5f5;
}

.api-test-modal .ant-modal-body::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 3px;
}

.api-test-modal .ant-modal-body::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.25);
}

.api-test-modal-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid #d9d9d9;
  background: #ffffff;
  border-radius: 8px 8px 0 0;
}

.modal-close-button {
  width: 22px;
  height: 22px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0;
  transition: background-color 0.2s;
}

.modal-close-button:hover {
  background-color: rgba(0, 0, 0, 0.06);
}

.modal-close-button .close-icon {
  font-size: 20px;
  line-height: 1;
  color: rgba(0, 0, 0, 0.45);
}

.endpoint-title {
  margin-bottom: 16px;
}

.endpoint-url {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
  padding: 8px 10px 8px 16px;
  background-color: var(--endpoint-bg-color);
  border-radius: 5px;
}

.endpoint-description {
  margin-bottom: 24px;
}

.request-section,
.response-section {
  /* margin-bottom: 32px; */
}

.response-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  gap: 8px;
  margin-bottom: 18px;
}

.response-header .section-heading {
  margin-bottom: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.4em;
}

.response-tags-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
}

.content-type {
  font-family: 'Share Tech Mono', monospace;
  font-size: 14px;
  line-height: 1.571em;
  color: rgba(0, 0, 0, 0.88);
}

.parameters-list,
.response-example {
  background: var(--parameter-bg-color);
  padding: 16px;
  border-radius: 4px;
  font-family: monospace;
}

.parameters-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* .parameter-item { */
/* border: 1px solid var(--param-border-color); */
/* padding: 12px; */
/* border-radius: 8px; */
/* background: var(--parameter-bg-color); */
/* width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 4px;
  } */

.section-title,
.section-heading {
  margin-bottom: 16px;
  font-weight: bold;
}

.response-tag {
  color: var(--mention-hightlight-text-color);
  margin-right: 0;
  cursor: pointer;
  padding: 1px 8px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 1.667em;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.placeholder {
  text-align: center;
  color: var(--placeholder-color);
  font-size: 16px;
}

.success {
  background-color: #f6ffed;
  color: #389e0d;
  border: none;
}

.redirect {
  background-color: #fff7e6;
  color: #fa8c16;
  border: none;
}

.client-error {
  background-color: #fff1f0;
  color: #f5222d;
  border: none;
}

.server-error {
  background-color: #f9f0ff;
  color: #722ed1;
  border: none;
}

.unknown {
  background-color: #f5f5f5;
  color: #8c8c8c;
  border: none;
}

.success.active {
  box-shadow: 0 0 8px 2px rgba(56, 158, 13, 0.3);
  border: 1px solid #389e0d;
  transform: scale(1.05);
}

.redirect.active {
  box-shadow: 0 0 8px 2px rgba(250, 140, 22, 0.3);
  border: 1px solid #fa8c16;
  transform: scale(1.05);
}

.client-error.active {
  box-shadow: 0 0 8px 2px rgba(245, 34, 45, 0.3);
  border: 1px solid #f5222d;
  transform: scale(1.05);
}

.server-error.active {
  box-shadow: 0 0 8px 2px rgba(114, 46, 209, 0.3);
  border: 1px solid #722ed1;
  transform: scale(1.05);
}

.unknown.active {
  box-shadow: 0 0 8px 2px rgba(140, 140, 140, 0.3);
  border: 1px solid #8c8c8c;
  transform: scale(1.05);
}

.hide-icon .ant-tree-iconEle,
.hide-icon .ant-tree-switcher {
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ApiDocsViewer/apiDocsViewer.css"],"names":[],"mappings":"AAAA;;KAEK;;AAEL;EACE,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,UAAU;EACV,kBAAkB;EAClB;;;wCAGsC;AACxC;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,0BAA0B;EAC1B,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;;EAEE,qCAAqC;EACrC,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sBAAsB;AACtB,iDAAiD;AACjD,mBAAmB;AACnB,wBAAwB;AACxB,2CAA2C;AAC3C;;;;KAIK;;AAEL;;EAEE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;AAC1B","sourcesContent":["/* .api-docs-viewer {\n    min-height: 100vh;\n  } */\n\n.endpoint-path {\n  font-weight: 600;\n}\n\n.sidebar {\n  background-color: var(--sidemenu-background-color) !important;\n  border-right: 1px solid var(--border-color);\n}\n\n.sidebar-header {\n  border-bottom: 1px solid var(--border-color);\n}\n\n.menu {\n  background-color: var(--sidemenu-background-color) !important;\n  border: none;\n}\n\n.endpoint-content {\n  padding: 24px;\n  /* max-width: 900px; */\n  margin: 0 auto;\n}\n\n/* API Test Modal Styling */\n.api-test-modal .ant-modal-content {\n  padding: 0;\n  border-radius: 8px;\n  box-shadow:\n    0px 9px 28px 8px rgba(0, 0, 0, 0.05),\n    0px 3px 6px -4px rgba(0, 0, 0, 0.12),\n    0px 6px 16px 0px rgba(0, 0, 0, 0.08);\n}\n\n.api-test-modal .ant-modal-body {\n  padding: 0;\n  max-height: calc(100vh - 120px);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.api-test-modal .ant-modal-body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.api-test-modal .ant-modal-body::-webkit-scrollbar-track {\n  background: #f5f5f5;\n}\n\n.api-test-modal .ant-modal-body::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.15);\n  border-radius: 3px;\n}\n\n.api-test-modal .ant-modal-body::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.25);\n}\n\n.api-test-modal-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px;\n  border-bottom: 1px solid #d9d9d9;\n  background: #ffffff;\n  border-radius: 8px 8px 0 0;\n}\n\n.modal-close-button {\n  width: 22px;\n  height: 22px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  padding: 0;\n  transition: background-color 0.2s;\n}\n\n.modal-close-button:hover {\n  background-color: rgba(0, 0, 0, 0.06);\n}\n\n.modal-close-button .close-icon {\n  font-size: 20px;\n  line-height: 1;\n  color: rgba(0, 0, 0, 0.45);\n}\n\n.endpoint-title {\n  margin-bottom: 16px;\n}\n\n.endpoint-url {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 24px;\n  padding: 8px 10px 8px 16px;\n  background-color: var(--endpoint-bg-color);\n  border-radius: 5px;\n}\n\n.endpoint-description {\n  margin-bottom: 24px;\n}\n\n.request-section,\n.response-section {\n  /* margin-bottom: 32px; */\n}\n\n.response-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  gap: 8px;\n  margin-bottom: 18px;\n}\n\n.response-header .section-heading {\n  margin-bottom: 0;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 1.4em;\n}\n\n.response-tags-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 4px;\n}\n\n.content-type {\n  font-family: 'Share Tech Mono', monospace;\n  font-size: 14px;\n  line-height: 1.571em;\n  color: rgba(0, 0, 0, 0.88);\n}\n\n.parameters-list,\n.response-example {\n  background: var(--parameter-bg-color);\n  padding: 16px;\n  border-radius: 4px;\n  font-family: monospace;\n}\n\n.parameters-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* .parameter-item { */\n/* border: 1px solid var(--param-border-color); */\n/* padding: 12px; */\n/* border-radius: 8px; */\n/* background: var(--parameter-bg-color); */\n/* width: 100%;\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    grid-gap: 4px;\n  } */\n\n.section-title,\n.section-heading {\n  margin-bottom: 16px;\n  font-weight: bold;\n}\n\n.response-tag {\n  color: var(--mention-hightlight-text-color);\n  margin-right: 0;\n  cursor: pointer;\n  padding: 1px 8px;\n  border-radius: 4px;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 1.667em;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.placeholder {\n  text-align: center;\n  color: var(--placeholder-color);\n  font-size: 16px;\n}\n\n.success {\n  background-color: #f6ffed;\n  color: #389e0d;\n  border: none;\n}\n\n.redirect {\n  background-color: #fff7e6;\n  color: #fa8c16;\n  border: none;\n}\n\n.client-error {\n  background-color: #fff1f0;\n  color: #f5222d;\n  border: none;\n}\n\n.server-error {\n  background-color: #f9f0ff;\n  color: #722ed1;\n  border: none;\n}\n\n.unknown {\n  background-color: #f5f5f5;\n  color: #8c8c8c;\n  border: none;\n}\n\n.success.active {\n  box-shadow: 0 0 8px 2px rgba(56, 158, 13, 0.3);\n  border: 1px solid #389e0d;\n  transform: scale(1.05);\n}\n\n.redirect.active {\n  box-shadow: 0 0 8px 2px rgba(250, 140, 22, 0.3);\n  border: 1px solid #fa8c16;\n  transform: scale(1.05);\n}\n\n.client-error.active {\n  box-shadow: 0 0 8px 2px rgba(245, 34, 45, 0.3);\n  border: 1px solid #f5222d;\n  transform: scale(1.05);\n}\n\n.server-error.active {\n  box-shadow: 0 0 8px 2px rgba(114, 46, 209, 0.3);\n  border: 1px solid #722ed1;\n  transform: scale(1.05);\n}\n\n.unknown.active {\n  box-shadow: 0 0 8px 2px rgba(140, 140, 140, 0.3);\n  border: 1px solid #8c8c8c;\n  transform: scale(1.05);\n}\n\n.hide-icon .ant-tree-iconEle,\n.hide-icon .ant-tree-switcher {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
